import styled from "@emotion/styled"
import DropdownMenu from "../Radiate/DropdownMenu/DropdownMenu"

import PopperContainer from "../Radiate/PopperContainer/PopperContainer"

export const LocaleGroupButton = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 4px;
  height: 40px;
  border-radius: 4px;
  background: ${(props) => props.selected ? props.theme.themeColorHighlight : "white"} ;
  color: ${(props) => props.selected ? "#ffffff" : props.theme.gray6};
  cursor: pointer;
  justify-content: space-between;

  .locale-group-name {
    font-weight: bold;
  }
`

export const Label = styled.div`
  padding: 4px;
`

export const LocalisedButton = styled.div`
  height: ${(props) => props.open ? "122px" : "40px"};
  box-sizing: border-box;
  transition: height 0.3s ease-out;
  background: #ffffff;
  overflow: hidden ;
`

export const TypeButton = styled.div`
  padding: 4px 16px;
  color: ${(props) => props.theme.gray6};
  background: ${(props) => props.selected ? props.theme.themeColorHighlight : "white"} ;
  border-radius: 4px;
  color: ${(props) => props.selected ? "#ffffff" : props.theme.gray6} ;
  cursor: pointer;

  >.icon {
    padding-right: 4px;
  }
`

export const TypeButtonWrapper = styled.div`
  height: 54px;
  transition: height 0.3s ease-out;
  z-index: ${(props) => props.zIndex};
  background: white;
`

export const AddLocalisedButton = styled.div`
  border: 1px dashed ${(props) => props.theme.gray4};
  padding: 4px;
  border-radius: 4px;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.gray4};
  cursor: pointer;
  align-items: center;

  >.icon {
    padding-right: 8px;
  }

`

export const StyledPopperContainer = styled(PopperContainer)`
  .popper-dropdown {
    top: 8px !important;
    width: calc(100% - 16px);
  }
`

export const AddLocaleGroupContainer = styled.div`
  padding: 8px;
  width: 100%;

  .confirm-button {
    margin-top: 8px;
    width: 100%;
  }
`

export const Tag = styled.div`
  padding: 2px;
  font-size: 0.6rem;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.success};
  color: ${(props) => props.theme.success};
  margin-left: 4px;
`

export const SDropdownMenu = styled(DropdownMenu)`
  /* height: 43px;
  min-height: 43px;

  >span {
    >span {
      .box-button-container {
        height: 43px;
        min-height: 43px;
      }
    }
  } */

  
`
